import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import DocuSignReaderForm from '../forms/docusign-reader-form';
import { docuSignReaderValidationSchema } from '../schema/docusignReader.js';

export default function DocuSignReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'DocuSign Reader Node Details',
        altText: 'DocuSign Reader Node',
        defaultLabel: 'DocuSign Reader Node',
      }}
    >
      <CommonNode
        FormComponent={DocuSignReaderForm}
        schemaResolver={docuSignReaderValidationSchema}
      />
    </NodeProvider>
  );
}
